import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AnnouncementItemContentRequest } from '@/model';
import { previewAnnouncementAPI } from '@/service';

const previewAnnouncementBaseQueryKey = 'previewAnnouncement';
const previewAnnouncementQueryKey = (request: AnnouncementItemContentRequest) => [
  previewAnnouncementBaseQueryKey,
  request,
];

export const usePreviewAnnouncementQuery = (
  request: AnnouncementItemContentRequest,
  enabled = true,
) => {
  return useQuery({
    queryKey: previewAnnouncementQueryKey(request),
    queryFn: () => previewAnnouncementAPI(request),
    placeholderData: keepPreviousData,
    enabled,
  });
};
